<template>
  <div
    v-if="currentModule"
    class="page-toolbar bg-white shadow-sm p-3 justify-content-between"
  >
    <breadcrumb />
    <div class="actions__block">
      <div class="actions__block">
        <label for="isDragModeEnabled">Sorting mode</label>
        <b-form-checkbox
          id="isDragModeEnabled"
          v-model="isDragModeEnabled.isDragModeEnabled"
          switch
        />
      </div>
      <b-button
        v-if="canCreateFolder(currentModule.currentUserPermissionLevel)"
        id="createNewFolder"
        size="sm"
        variant="secondary"
        @click="showFolderModal"
      >
        <font-awesome-icon :icon="['fas', 'folder-plus']" />
        Create new Folder
      </b-button>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/core/components/Breadcrumb.vue';
import moduleViewMixin from '@/core/mixins/module-view.mixin';
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('dataManagement');
const {mapState: sidebarMapState} = createNamespacedHelpers('sidebar');

export default {
  name: 'ModuleHeader',
  components: {Breadcrumb},
  mixins: [moduleViewMixin],
  data() {
    return {
      currentModule: null,
    };
  },
  watch:{
    modules: {
      handler(val){
        if(!val) return;
        const moduleUuid = this.$route.params.moduleUuid;
        this.currentModule = val.find(el => el.moduleGuid === moduleUuid);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      permissionTypes: state => state.permissionTypes,
    }),
    ...sidebarMapState({
      isDragModeEnabled: state => state,
      selectedModuleName: state => state.selectedModuleName,
      modules: state => state.menuItems,
    }),
  },
  methods: {
    ...mapActions(['showFolderModal']),
  },
};
</script>

<style scoped lang="scss">
.actions__block {
  display: flex;
  align-items: center;
  gap: 10px;

  label, input {
    margin-bottom: 0;
    cursor: pointer;
  }
}
</style>